import { configureStore } from "@reduxjs/toolkit";
import uiStates from "../components/common/Features/uiStates";
import userData from "../components/common/Features/userData";

import getPostsSlice from "../components/ContentLibrary/Features/getPostsSlice";
import getPostTagsSlice from "../components/ContentLibrary/Features/getPostTagsSlice";
import shopifyStateSlice from "../components/ContentLibrary/Features/shopifyStateSlice";
import newPostConfigSlice from "../components/CreateNewPost/features/newPostConfigSlice";
import polotnoStatesSlice from "../components/Polotno/features/polotnoStatesSlice";
import { reducer } from "./reducers";

const mainStore = configureStore({
  reducer: {
    globalReducer: reducer,
    getPosts: getPostsSlice,
    getPostTags: getPostTagsSlice,
    newPostConfig: newPostConfigSlice,
    userData: userData,
    uiStates: uiStates,
    shopifyStates: shopifyStateSlice,
    polotnoStates: polotnoStatesSlice,
  },
});

export default mainStore;
